import React from 'react';
import AddNewProduct from './AddNewProduct';
import './ProductImagesStockHubModal.css';

/**
 * Single scroll: same "Photos, variant colors & stock" block and save path as Add/Edit Product.
 */
const ProductImagesStockHubModal = ({ product, currentUser, onClose, onStockUpdated }) => {
  const productId = product?.id || product?._id;
  const name = product?.name || 'Product';

  if (!productId) return null;

  return (
    <div className="pish-hub-modal" role="dialog" aria-modal="true" aria-labelledby="pish-hub-title">
      <div className="pish-hub-backdrop" onClick={onClose} aria-hidden="true" />
      <div className="pish-hub-panel" onClick={(e) => e.stopPropagation()}>
        <header className="pish-hub-header">
          <div className="pish-hub-heading">
            <span className="pish-hub-kicker">Product</span>
            <h2 id="pish-hub-title">Photos &amp; inventory</h2>
            <p className="pish-hub-product-name">{name}</p>
          </div>
          <button type="button" className="pish-hub-close" onClick={onClose} aria-label="Close">
            <i className="fas fa-times" />
          </button>
        </header>

        <div className="pish-hub-body pish-hub-body--add-product-flow">
          <AddNewProduct
            variantHubOnly
            editingProduct={product}
            onNavigate={() => {}}
            onEditComplete={() => {
              if (onStockUpdated) onStockUpdated();
              onClose();
            }}
            currentUser={currentUser}
          />
        </div>
      </div>
    </div>
  );
};

export default ProductImagesStockHubModal;
